import { useOutletContext, Link } from "react-router-dom";
import { useEffect, useState, useRef } from 'react';
import { apiInfos } from "../Assets/API/apiInfos";
import { PageNames, GroupNames, ApiTypes, PageDisplayNames, PAGE_TITLE_BASE } from '../Assets/variables';
import { Helmet } from "react-helmet-async";

const GroupList = [
    { groupName: GroupNames.ReferenceData, className: "reference-data" },
    { groupName: GroupNames.MarketData, className: "market-data" },
    { groupName: GroupNames.Search, className: "search" },
    { groupName: GroupNames.EstimatesAndFundamentals, className: "estimates-and-fundamentals" },
    { groupName: GroupNames.CorporateActions, className: "corporate-actions" },
    { groupName: GroupNames.News, className: "news" },
    { groupName: GroupNames.Tax, className: "tax" },
    { groupName: GroupNames.InvestorProtection, className: "investor-protection" },
];

const Catalog = () => {
    const {sidebarToggler, setActivePageItem} = useOutletContext();
    const [filteredCards, setFilteredCards] = useState(apiInfos);
    const [activeCategoryFilters, setActiveCategoryFilters] = useState([]);
    const [activeTypeFilters, setActiveTypeFilters] = useState([]);
    const [count, setCount] = useState(0);
    const webApiButtonRef = useRef(null);
    const bulkApiButtonRef = useRef(null);

    useEffect(() => {
        sidebarToggler(true);
        setActivePageItem(PageNames.Catalog);
    }, []);

    function filterByCategory(groups) {
        let activeCategories = activeCategoryFilters;

        groups.map((group) => {
            if (activeCategoryFilters.includes(group)) {
                let indexOfCategory = activeCategoryFilters.indexOf(group);
                activeCategories.splice(indexOfCategory, 1);
                setActiveCategoryFilters(activeCategories);
            } else {
                activeCategories.push(group);
                setActiveCategoryFilters(activeCategories);
            }
        });

        setCount(count + 1)
    }

    function filterByType(types) {
        let activeTypes = activeTypeFilters;

        types.map((apiType) => {
            if (activeTypeFilters.includes(apiType)) {
                let indexOfType = activeTypeFilters.indexOf(apiType);
                activeTypes.splice(indexOfType, 1);
                setActiveTypeFilters(activeTypes);
            } else {
                activeTypes.push(apiType);
                setActiveTypeFilters(activeTypes);
            }
        });

        setCount(count + 1)
    }

    useEffect(() => {
        let cardsWithFilters = apiInfos;

        if (activeCategoryFilters.length > 0 || activeTypeFilters.length > 0) {
            if (activeCategoryFilters.length > 0) {
                cardsWithFilters = cardsWithFilters.filter((card) => activeCategoryFilters.includes(card.group))
            }
    
            if (activeTypeFilters.length > 0) {
                cardsWithFilters = cardsWithFilters.filter((card) => activeTypeFilters.includes(card.type))
            }

            setFilteredCards(cardsWithFilters)
        } else {
            setFilteredCards(apiInfos)
        }
        
    }, [count]);

    function setActiveFilter(event) {
        if (event.currentTarget.classList.contains("active")) {
            event.currentTarget.classList.remove("active")
        } else {
            event.currentTarget.classList.add("active")
        }
    }

    function setGroupColors(apiGroup) {
        return GroupList.filter((group) => group.groupName === apiGroup)[0].className;
    }

    return (
        <>
            <Helmet>
                <title>{`${PAGE_TITLE_BASE}${PageDisplayNames.Catalog}`}</title>
                <meta name="description" content={`${PageDisplayNames.Catalog} page of the SIX Web API Portal`} />
                <link rel="canonical" href={`/${PageNames.Catalog}`} />
            </Helmet>
            <div className="catalog">
                <div className="catalog-filters">
                    <div className="catalog-filters-list">
                        <div className="catalog-filters-inner">
                            <span>API</span>
                            <button ref={webApiButtonRef} onClick={(event) => { filterByType([ApiTypes.WebApi]); setActiveFilter(event) }}>{ApiTypes.WebApi}</button>
                            <button ref={bulkApiButtonRef} onClick={(event) => { filterByType([ApiTypes.BulkApi]); setActiveFilter(event) }}>{ApiTypes.BulkApi}</button>
                        </div>
                        <div className="catalog-filters-inner">
                            <span>Category</span>
                            <button onClick={(event) => { filterByCategory([GroupNames.ReferenceData]); setActiveFilter(event) }}>{GroupNames.ReferenceData}</button>
                            <button onClick={(event) => { filterByCategory([GroupNames.MarketData]); setActiveFilter(event) }}>{GroupNames.MarketData}</button>
                            <button onClick={(event) => { filterByCategory([GroupNames.CorporateActions]); setActiveFilter(event) }}>{GroupNames.CorporateActions}</button>
                            <button onClick={(event) => { filterByCategory([GroupNames.EstimatesAndFundamentals]); setActiveFilter(event) }}>{GroupNames.EstimatesAndFundamentals}</button>
                            <button onClick={(event) => { filterByCategory([GroupNames.Search]); setActiveFilter(event) }}>{GroupNames.Search}</button>
                            <button onClick={(event) => { filterByCategory([GroupNames.Tax]); setActiveFilter(event) }}>{GroupNames.Tax}</button>
                            <button onClick={(event) => { filterByCategory([GroupNames.InvestorProtection]); setActiveFilter(event) }}>{GroupNames.InvestorProtection}</button>
                        </div>
                    </div>
                </div>
                <div className="catalog-list" >
                    { filteredCards.map(apiInfo => (
                        <Link
                            to={`/catalog/${apiInfo.apiName}`}
                            className="catalog-list-item">
                        <div className="catalog-list-item__content">
                        <h1>{apiInfo.apiTitle} { !!apiInfo?.beta && <span className="beta-tag">{`${"(Beta)"}`}</span> }</h1>
                        <p>{apiInfo.description}</p>
                        </div>
                        <div className="catalog-list-item__group-and-version">
                            <span className={"catalog-list-item__type"}>{apiInfo.type}</span>
                            <span className={"catalog-list-item__group " + setGroupColors(apiInfo.group)}>{apiInfo.group}</span>
                        </div>
                    </Link>
                    )) }
                    { !filteredCards.length &&
                        <div className="catalog-list__no-results">
                            <h4>No APIs with the set filters were found</h4>
                        </div>
                    }
                </div>
            </div>
        </>
    )
};

export default Catalog;
